export const createSelectors = (keys) => {
  return Object.fromEntries(keys.map((key) => [key, (state) => state[key]]));
};
